<template>
  <main>
    <v-container>
      <v-row>
        <v-col>
          <v-card outlined>
            <!-- Tabs -->
            <v-tabs v-model="tab" background-color="primary" dark show-arrows>
              <v-tab>Details</v-tab>
            </v-tabs>

            <!-- Tab Items -->
            <v-tabs-items v-model="tab">
              <v-tab-item :transition="false" :reverse-transition="false">
                <v-form ref="form" v-model="valid" class="py-4 px-4" lazy-validation>
                  <v-text-field v-model="formData.name" label="Name" :required="true" :rules="rules.name" />
                  <autocomplete-input
                    v-model="formData.type"
                    :items="getItemsForOption('entityTypeTypes')"
                    :rules="rules.type"
                    label="Entity Type"
                    required
                  />
                </v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col class="d-flex items-center justify-end">
          <v-btn :loading="loading.cancelling" :disabled="disabled" class="mr-4" text @click="cancelCreatingResource">
            Cancel
          </v-btn>
          <v-btn
            :loading="loading.creatingAlt"
            :disabled="disabled"
            class="mr-4"
            color="primary"
            @click="createResourceWithoutRedirect"
          >
            Create & Add Another
          </v-btn>
          <v-btn :loading="loading.creating" :disabled="disabled" color="primary" @click="createResourceWithRedirect">
            Create {{ resourceType }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import PermissionsHandler from '@/mixins/permissions-handler'
import CreateResource from '@/mixins/create-resource'
import AutocompleteInput from '@/components/forms/autocomplete-input.vue'

export default {
  name: 'EntityTypesCreate',
  components: { AutocompleteInput },
  mixins: [PermissionsHandler, CreateResource],
  data() {
    return {
      resourceType: 'Entity Type',
      resourcePrefix: 'entity-types',
      rules: {
        name: [v => !!v || 'Name is required', v => (!!v && v.length > 0) || 'Name must be greater than 0'],
        type: [v => !!v || 'Type is required', v => (!!v && v.length > 0) || 'Type must be greater than 0'],
      },
      formData: {
        name: null,
        type: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      resource: 'entityTypes/getEntityType',
    }),
    ...mapGetters('options', ['getItemsForOption']),
  },
  methods: {
    ...mapActions({
      create: 'entityTypes/create',
    }),
    async createResource() {
      return await this.create({ formData: this.formData })
    },
  },
}
</script>
